import { atom } from 'jotai';

export const serversRestartingAtom = atom<{ [key: string]: boolean }>({});
